import { useEffect, useState } from "react";
import { X } from "lucide-react";
import { apiFetch } from "../lib/api-client";

export function InvoicePdfPane({ invoiceId, label, onClose }: { invoiceId: string; label: string; onClose: () => void }) {
  const [document, setDocument] = useState<{ id: string; url: string } | null>(null);
  const [error, setError] = useState("");
  useEffect(() => {
    const controller = new AbortController();
    let objectUrl = "";
    setDocument(null); setError("");
    void (async () => {
      try {
        const response = await apiFetch(`/api/v1/workspace/invoices/${encodeURIComponent(invoiceId)}/pdf`, { signal: controller.signal });
        if (!response.ok) throw new Error("We couldn’t load this PDF. Close the preview and try again.");
        const blob = await response.blob();
        if (controller.signal.aborted) return;
        objectUrl = URL.createObjectURL(blob);
        setDocument({ id: invoiceId, url: objectUrl });
      } catch (cause) {
        if (!controller.signal.aborted) setError(cause instanceof Error ? cause.message : "PDF preview is unavailable.");
      }
    })();
    return () => { controller.abort(); if (objectUrl) URL.revokeObjectURL(objectUrl); };
  }, [invoiceId]);
  const url = document?.id === invoiceId ? document.url : "";
  return <section className="job-invoice-pdf-pane" aria-label={`${label} PDF preview`} onKeyDown={event => {
    if (event.key === "Escape") { event.stopPropagation(); onClose(); }
  }}>
    <header><h2>{label} PDF</h2><button type="button" autoFocus aria-label="Close PDF preview" onClick={onClose}><X size={18} aria-hidden /></button></header>
    {error ? <p role="alert">{error}</p> : url ? <>
      <div className="job-pdf-links"><a href={url} target="_blank" rel="noreferrer">Open in new tab</a><a href={url} download={`invoice-${invoiceId}.pdf`}>Download PDF</a></div>
      <iframe src={url} title={`${label} PDF`} />
    </> : <p role="status">Loading PDF…</p>}
  </section>;
}
